module.exports = __webpack_public_path__ + "img/about-photo-4.0a2fab9.jpg";